<div class="mini-chart">
  <canvas #miniChart></canvas>
</div>
